import EntityBase from '@/data/EntityBase';

export default class TimeHistoryState extends EntityBase({
  updating: 0,
}) {}
